module.exports = __webpack_public_path__ + "static/banner_cpa_2026_mobile-1992998e93213e94b6856ff3ca90148c.jpeg";